import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// Patch ResizeObserver to suppress benign loop errors (Radix UI / shadcn dropdowns)
const RO = window.ResizeObserver;
window.ResizeObserver = class extends RO {
  constructor(cb) {
    super((entries, observer) => {
      requestAnimationFrame(() => { cb(entries, observer); });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
